import React, { Component } from "react";
import { Card, CardTitle, FlatButton, Divider } from "material-ui";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import FilterIndex from "../FilterIndex";
import formatDate from "../../../utils/formatDate";

export default class PendingClientUpdates extends Component {
  constructor(props) {
    super(props);

    this.renderTable = this.renderTable.bind(this);
    this.viewButton = this.viewButton.bind(this);
  }

  viewButton(cell, row) {
    let url = `/job/salesForceClients/ProcessClientUpdate/${cell}`;
    return (
      <FlatButton
        label="View"
        backgroundColor="#E0E0E0"
        hoverColor="#BDBDBD"
        onClick={this.props.performRoute.bind(this, url)}
      />
    );
  }

  renderTable() {
    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let filter = { type: "TextFilter", delay: 500 };
      return (
        <div>
          <BootstrapTable data={this.props.workOrders} pagination>
            <TableHeaderColumn
              dataField="uid__c"
              filter={filter}
              dataSort
              isKey
              width="125"
            >
              ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="name"
              dataSort
              filter={filter}
              dataFormat={this.linkFormatter}
            >
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="createdAt"
              dataSort
              filter={filter}
              dataFormat={(d) => formatDate(new Date(d))}
            >
              Created
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="comment"
              dataSort
              filter={filter}
              width="300"
            >
              Comment
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="_id"
              dataFormat={this.viewButton}
              width="100"
            ></TableHeaderColumn>
          </BootstrapTable>
        </div>
      );
    }
  }

  render() {
    return (
      <Card
        className="container"
        zDepth={2}
        style={{ marginTop: "2em", padding: "2em 7em 0em 7em" }}
      >
        <CardTitle title="Client Updates" />
        <Divider style={{ margin: "1em 1em" }} />
        <FilterIndex
          url="clients/clientUpdates"
          filterKey="status"
          {...this.props}
        />
        <br />
        {this.renderTable()}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/clients/PendingClientUpdates.js